import { Container, Box, IconButton, Menu, Button } from "@mui/material";
import { useState, useEffect } from "react";
import CustomButton from "../customComponent/CustomButton";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import InspStatusPage from "../../pages/InspStatusPage";
import { CachedIcon, FilterListIcon } from "../../icons";
import { InspStatusFilter } from "./InspStatusFilter.js";
import useFilterOption from "../../hooks/useFilterOption.js";
import { inspStatusFilterState, queryOptionsState } from "../../recoil";
import { useRecoilState, useRecoilValue, useResetRecoilState } from "recoil";

interface QueryOptions {
  search_type?: number;
  keyword?: string | null;
  sort_type?: string | null;
  sort?: string | null;
  page?: number;
  pageSize?: number;
}

export default function InspStatusMain() {
  const navigate = useNavigate();
  const [queryOption, setQueryOption] = useState<QueryOptions>({
    search_type: 0,
    keyword: null,
    sort_type: null,
    sort: null,
    page: 1,
    pageSize: 20,
  });
  const [openFilterMenu, setOpenFilterMenu] = useState(false);
  const [filterAnchorEl, setFilterAnchorEl] = useState<HTMLElement | null>(
    null
  );
  const [optionMenuOpen, setOptionMenuOpen] = useState(false);
  const inspStatusFilterHook = useFilterOption(inspStatusFilterState);
  const resetInspStatusFilter = useResetRecoilState(inspStatusFilterState);
  const resetQueryOption = useResetRecoilState(queryOptionsState);
  const [isFilterReset, setIsFilterReset] = useState(false);

  const handleRefresh = async () => {
    resetInspStatusFilter();
    resetQueryOption();
    inspStatusFilterHook.resetAllFilterOptions();
    setQueryOption((prev) => ({
      search_type: 0,
      keyword: null,
      sort_type: null,
      sort: null,
      page: 1,
      pageSize: 20,
    }));
    setIsFilterReset(true);
  };

  const handleOpenFilterMenu = (event: React.MouseEvent<HTMLElement>) => {
    setFilterAnchorEl(event.currentTarget);
    setOpenFilterMenu(true);
  };

  const handleCloseFilterMenu = () => {
    setOpenFilterMenu(false);
    setFilterAnchorEl(null);
  };

  const handleApplyFilter = async () => {
    inspStatusFilterHook.applyFilterOption();
    handleCloseFilterMenu();
    setQueryOption((prev) => ({
      ...prev,
      ...inspStatusFilterHook.filterOption,
      page: 1,
    }));
  };

  const filterModalStyle = {
    width: "fit-content",
    height: "fit-content",
    bgcolor: "var(--modal-color)",
    borderRadius: "4px",
    padding: "10px 12px 5px 12px",
  };
  return (
    <>
      <div className="p-8">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold text-gray-900">검사 현황</h1>
        </div>
      </div>
      <Container
        sx={{ display: "flex", flexDirection: "column" }}
        maxWidth={false}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            height: "42px",
          }}
        >
          <Box>
            <IconButton onClick={handleRefresh}>
              <CachedIcon
                sx={{ fontSize: "20px", color: "var(--button-color)" }}
              />
            </IconButton>
            <IconButton onClick={handleOpenFilterMenu}>
              <FilterListIcon
                sx={{ fontSize: "20px", color: "var(--button-color)" }}
              />
            </IconButton>
          </Box>
        </Box>
        <Menu
          anchorEl={filterAnchorEl}
          open={openFilterMenu}
          onClose={handleCloseFilterMenu}
        >
          <Box sx={filterModalStyle}>
            <InspStatusFilter clientIps={null} lotList={null} />
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                style={{ marginTop: "10px", color: "var(--button-color)" }}
                onClick={handleApplyFilter}
              >
                {t("Apply")}
              </Button>
            </div>
          </Box>
        </Menu>
        <InspStatusPage
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
          queryOption={queryOption}
          setQueryOption={setQueryOption}
        />
      </Container>
    </>
  );
}
